import React from 'react'
import { Button, Result, Space, Table } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { rubricActions } from '../../../../../store/slices/rubric.slice'
import { useFetchRubricsQuery } from '../../../../../store/apis/rubric.api'

const RubricsTable = () => {
    const dispatch = useDispatch()
    const { token } = useParams()
    const { data: rubrics, isFetching, error, refetch } = useFetchRubricsQuery({ token })

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (name, rubric) => (
                <a onClick={() => dispatch(rubricActions.setEditingRubricId(rubric.id))} data-test="rubric-link">
                    {name}
                </a>
            ),
        },
        {
            title: 'Categories',
            dataIndex: 'categories',
            key: 'categories',
            width: 100,
            render: (_, rubric) => rubric.categories?.length || 0,
        },
        {
            title: 'Actions',
            key: 'actions',
            width: 120,
            render: (_, rubric) => (
                <Space>
                    <Button
                        type='text'
                        icon={<EditOutlined />}
                        onClick={() => dispatch(rubricActions.setEditingRubricId(rubric.id))}
                        title='Edit'
                    />
                </Space>
            ),
        },
    ]

    if (error) {
        return (
            <Result
                status='error'
                title='Failed to load rubrics'
                subTitle={error?.message || 'An error occurred'}
                extra={[
                    <Button key='try' onClick={() => refetch()} loading={isFetching}>
                        Try Again
                    </Button>,
                ]}
            />
        )
    }

    return (
        <Table
            columns={columns}
            dataSource={rubrics}
            rowKey='id'
            pagination={false}
            loading={{ spinning: isFetching, tip: 'Loading rubrics...' }}
        />
    )
}

export default RubricsTable

